module.exports = __webpack_public_path__ + "img/button-secondary-plus.6eda9f4a.svg";